var MaxFileSizeClass = (function () {
    function MaxFileSizeClass() {
    }
    return MaxFileSizeClass;
}());
//# sourceMappingURL=MaxFileSizeClass.js.map